import * as React from 'react'
import {FC} from 'react'
import {CalcMode} from '../../types/global-options'
import ControlBlockModeAgent, {
    ControlBlockModeAgentPropsInterface,
} from '../control-block-mode-agent'
// @ts-ignore
import ControlBlock, {ControlBlockPropsInterface} from '../control-block'

interface ControlBlockModeSwitchPropsInterface {
    mode: CalcMode
}

type ControlBlockModeSwitchPropsType = ControlBlockModeSwitchPropsInterface &
    ControlBlockPropsInterface &
    ControlBlockModeAgentPropsInterface

const ControlBlockModeSwitch: FC<ControlBlockModeSwitchPropsType> = ({
    mode,
    currentStep,
    onNextClick,
    onPrevClick,
    nextDisabled,
    onSendPaymentLinkToEmail,
}) => {
    if (mode === 'agent')
        return (
            <ControlBlockModeAgent
                currentStep={currentStep}
                onNextClick={onNextClick}
                onPrevClick={onPrevClick}
                nextDisabled={nextDisabled}
                onSendPaymentLinkToEmail={onSendPaymentLinkToEmail}
            />
        )
    return (
        <ControlBlock
            currentStep={currentStep}
            onNextClick={onNextClick}
            onPrevClick={onPrevClick}
            nextDisabled={nextDisabled}
        />
    )
}

export default ControlBlockModeSwitch
